var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsProgressProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 7,
    viewBox: "0 0 78 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 7,
    rx: 3.5,
    fill: "#98911F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsProgressProcess);
export default __webpack_public_path__ + "static/media/ads-progress-process.e0ab64e4d406aa5b0422befbabc500b5.svg";
export { ForwardRef as ReactComponent };